import { Mode } from './Mode.js';
import { QRData } from './QRData.js';
/**
 * QR8BitByte
 *
 * @author Kazuhiko Arase
 */
export class QR8BitByte extends QRData {
    stringToBytes;
    constructor(data, stringToBytes) {
        super(Mode.MODE_8BIT_BYTE, data);
        this.stringToBytes = stringToBytes;
    }
    write(buffer) {
        const data = this.stringToBytes(this.getData());
        data.forEach(val => buffer.put(val, 8));
    }
    getLength() {
        return this.stringToBytes(this.getData()).length;
    }
}
//# sourceMappingURL=QR8BitByte.js.map